function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.3 4.6c-1.2.1-2.1 1.2-2.2 2.5C2 8.2 2 9.5 2 10.3c0 .9 0 2.2.1 3.3.1 1.3 1 2.4 2.2 2.5 1.4.1 3.3.3 5.7.3 2.4 0 4.3-.1 5.7-.3 1.2-.1 2.1-1.2 2.2-2.5.1-1.2.1-2.5.1-3.3 0-.8 0-2.1-.1-3.2-.1-1.3-1-2.4-2.2-2.5-1.3-.1-3.3-.2-5.7-.2-2.4 0-4.3.1-5.7.2zm4.1 3.2 4.1 2.5-4.1 2.5v-5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgSocialYoutube;